import httpClient from "@plugins/http";

const fetchContentMapKeywordByQuestionId = (questionId) => {
  return httpClient.get(`/apis/content-map-keyword/get-by-question-id/${questionId}`);
};

const fetchContentMapKeywordByContentMapId = (contentMapId) => {
  return httpClient.get(`/apis/content-map-keyword/get-by-content-map-id/${contentMapId}`);
};

const fetchContentMapsAndKeywordsByQuestionId = (questionId) => {
  return httpClient.get(`/apis/content-map/content-maps-and-keywords/${questionId}`);
};

export default {
  fetchContentMapKeywordByContentMapId,
  fetchContentMapKeywordByQuestionId,
  fetchContentMapsAndKeywordsByQuestionId,
};
